import { doRefreshToken  } from '../actions/authAction';

export const authMiddleware = store => next => action => {
  if (action.type.indexOf('REJECTED') !== -1) {
    const { payload } = action;
    if (payload instanceof Error) {
      if (payload.response !== null && payload.response !== undefined) {
        const { error } = payload.response.data;
        if (error && error.message === "The token has been blacklisted" && error.status_code === 401) {
          store.dispatch(doRefreshToken());
        }
      }
    } else if (action.type === '') {

    }
  }
  next(action);
}
